/* eslint-disable import/prefer-default-export */
export enum CampaignName {
  PointsForQuote2025 = '2025_points_for_quote',
  PointsForRenewal2025 = '2025_points_for_renewal',
  ReferAFriendReferrer2025 = '2025_refer_a_friend',
  ReferAFriendReferee2025 = '2025_refer_a_friend_referee_quote',
}
